module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/domofon-3-6c90e0a144edc886018b59f5c241a624.png";